import { useEffect, useRef } from 'react'
import { useFormikContext } from 'formik'
import { QuestionType } from 'civic-champs-shared/question-sets/types'
import { normalizeTargetForQuestionType } from 'question-sets/utils/question-target'

interface QuestionTypeTargetSyncProps {
  index: number
}

const QuestionTypeTargetSync = ({ index }: QuestionTypeTargetSyncProps) => {
  const { values, setFieldValue } =
    useFormikContext<{ questions: Array<{ questionType?: QuestionType; target?: string }> }>()
  const question = values.questions[index]
  const previousQuestionType = useRef(question?.questionType)

  useEffect(() => {
    const nextQuestionType = question?.questionType
    if (previousQuestionType.current === nextQuestionType) {
      return
    }

    const normalizedTarget = normalizeTargetForQuestionType(nextQuestionType, question?.target)
    setFieldValue(`questions[${index}].target`, normalizedTarget)
    previousQuestionType.current = nextQuestionType
  }, [index, question, setFieldValue])

  return null
}

export default QuestionTypeTargetSync
